module.exports = __webpack_public_path__ + "static/media/image_70.19659bdd.png";